var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3121 4.8L16.5121 0H2.63989V24H21.3599L21.3121 4.8ZM16.896 2.01562L19.3438 4.46344H16.896V2.01562ZM3.79208 22.8478V1.15219H15.7452V5.61609H20.1613L20.2082 22.8478H3.79208Z",
    fill: "current",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.216 3.64783H5.90381V4.56001H15.216V3.64783Z",
    fill: "current",
    stroke: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 8.9761H5.90381V9.88829H17.9516V8.9761Z",
    fill: "current",
    stroke: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 6.28781H5.90381V7.2H17.9516V6.28781Z",
    fill: "current",
    stroke: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 11.6161H5.90381V12.5283H17.9516V11.6161Z",
    fill: "current",
    stroke: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 14.3039H5.90381V15.2161H17.9516V14.3039Z",
    fill: "current",
    stroke: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 16.9439H5.90381V17.8561H17.9516V16.9439Z",
    fill: "current",
    stroke: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 19.6322H5.90381V20.5444H11.9999V19.6322Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.7b1c2dc9730c581b84682218dcb9c788.svg";
export { ForwardRef as ReactComponent };